function PageHeader({ children }) {
  return <h1 className="border-bottom mt-0 pb-1">{children}</h1>;
}

export default PageHeader;
